// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDtaVersionRequest
 */
export interface CreateDtaVersionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDtaVersionRequest
     */
    change_reason: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDtaVersionRequest
     */
    change_source?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDtaVersionRequest
     */
    effective_date?: string;
    /**
     * Version transition grace period in days
     * @type {number}
     * @memberof CreateDtaVersionRequest
     */
    grace_period_days?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDtaVersionRequest
     */
    upload_id?: string;
}

/**
 * Check if a given object implements the CreateDtaVersionRequest interface.
 */
export function instanceOfCreateDtaVersionRequest(value: object): value is CreateDtaVersionRequest {
    if (!('change_reason' in value) || value['change_reason'] === undefined) return false;
    return true;
}

export function CreateDtaVersionRequestFromJSON(json: any): CreateDtaVersionRequest {
    return CreateDtaVersionRequestFromJSONTyped(json, false);
}

export function CreateDtaVersionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDtaVersionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'change_reason': json['change_reason'],
        'change_source': json['change_source'] == null ? undefined : json['change_source'],
        'effective_date': json['effective_date'] == null ? undefined : json['effective_date'],
        'grace_period_days': json['grace_period_days'] == null ? undefined : json['grace_period_days'],
        'upload_id': json['upload_id'] == null ? undefined : json['upload_id'],
    };
}

export function CreateDtaVersionRequestToJSON(json: any): CreateDtaVersionRequest {
    return CreateDtaVersionRequestToJSONTyped(json, false);
}

export function CreateDtaVersionRequestToJSONTyped(value?: CreateDtaVersionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'change_reason': value['change_reason'],
        'change_source': value['change_source'],
        'effective_date': value['effective_date'],
        'grace_period_days': value['grace_period_days'],
        'upload_id': value['upload_id'],
    };
}
